import { api } from './api'
import type { User, UsersResponse, UpdateUserRequest } from '@/types/user'

export const usersApi = {
  getUsers: async (nextToken?: string): Promise<UsersResponse> => {
    console.log('🔍 Fetching users', { nextToken })
    const params = nextToken ? { next_token: nextToken } : {}
    const response = await api.get<UsersResponse>('/users', { params })
    console.log('✅ Fetched users:', response.data)
    return response.data
  },

  getUser: async (userId: string): Promise<User> => {
    console.log('🔍 Fetching user:', userId)
    const response = await api.get<User>(`/users/${userId}`)
    console.log('✅ Fetched user:', response.data)
    return response.data
  },

  createUser: async (userId: string): Promise<User> => {
    console.log('📝 Creating user:', userId)
    const response = await api.post<User>(`/users/${userId}`)
    console.log('✅ Created user:', response.data)
    return response.data
  },

  updateUser: async (request: UpdateUserRequest): Promise<User> => {
    console.log('📝 Updating user:', request)
    const response = await api.put<User>(`/users/${request.user_id}`, request)
    console.log('✅ Updated user:', response.data)
    return response.data
  },

  deleteUser: async (userId: string): Promise<void> => {
    console.log('🗑️ Deleting user:', userId)
    await api.delete(`/users/${userId}`)
    console.log('✅ Deleted user')
  }
}